<template>
    <oc-advanced-search class="mb-5" v-bind="attrs" v-on="$source.advancedSearchEvents" v-class="attrs.class" @filter="onFilter" />
</template>

<script>
export default {
    name: 'oc-advanced-search-after-header',
    inject: ['$source'],
    props: ['columns'],
    data() {
        return {}
    },
    computed: {
        attrs() {
            return Object.assign({
                filterParam: 'aflt_',
                items: this.$source.advancedSearchFilters
            }, this.$source.advancedSearch)
        }
    },
    methods: {
        onFilter(appliedFilters) {
            if( this.$source.goToPage !== undefined ) {
                this.$source.goToPage(1)
            }

            this.$source.conditionsState['advanced-filters'] = appliedFilters

            this.$source.$emit('on-filter', this.$source.conditionsState['advanced-filters'])
            this.$source.$emit('change-internal', this.$source.conditionsState)
        }
    }
}
</script>
